import {getDepartment, getUserInfo} from '../../utilities/storage';

import {
  ADD_AYUCARE_USER,
  GET_ASSIGNED_ORGS,
  GET_AYUCARE_USERS,
  GET_AYUCARE_USERS_WITHOUT_PARAMS,
  GET_ROLES,
  GET_STATES,
  GET_TIMEZONES,
  GET_USER_BY_ID,
  GET_USER_DEPTS,
  GET_USERS_FOR_ADMIN,
  REFRESH_TOKEN,
  SET_DOCTOR_PROFILE_TAB_VALUE,
  SET_SELECTED_DEPT,
  SET_TAB_VALUE,
  TOGGLE_EMAIL_UPDATE,
  TOGGLE_USER_ACTIVATION,
  UPDATE_USER
} from './UsersActions';

const initialState = {
  loggedInUser: getUserInfo() ? getUserInfo() : null,
  users: [],
  user: null,
  roles: [],
  depts: [],
  selectedDept: getDepartment() ? getDepartment() : null,
  states: [],
  timezones: [],
  orgs: [],
  token: null,
  tabValue: '1',
  doctorProfileTabValue: '1',
};


/**
 * reducer function to update state based on action
 * @param state: current state of the reducer
 * @param action: action to perform on the data
 * @returns {{update, updates: null}|{update: null, updates: null}|{update: null, updates: (null|*)}}
 * @constructor
 */
const AyucareUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DOCTOR_PROFILE_TAB_VALUE:
      return {
        ...state,
        doctorProfileTabValue: action.tabValue,
      };

    case SET_TAB_VALUE:
      return {
        ...state,
        tabValue: action.tabValue,
      };
    case GET_AYUCARE_USERS:
      return Object.assign({}, state, {
        users: action.users,
      });

    case GET_USERS_FOR_ADMIN:
      return Object.assign({}, state, {
        users: action.users,
      });

    case GET_AYUCARE_USERS_WITHOUT_PARAMS:
      return Object.assign({}, state, {
        users: action.users,
      });

    case ADD_AYUCARE_USER:
      return {
        ...state,
      };

    case GET_USER_BY_ID:
      return Object.assign({}, state, {
        user: action.user,
      });

    case UPDATE_USER: {
      return Object.assign({}, state, {
        user: action.user,
      });
    }

    case GET_ROLES:
      return Object.assign({}, state, {
        roles: action.roles,
      });

    case TOGGLE_USER_ACTIVATION:
      return {
        ...state,
        user: {
          ...state.user,
          enabled: action.user.enabled,
          isBanned: action.user.isBanned
        },
      };
    case GET_USER_DEPTS:
      return Object.assign({}, state, {
        depts: action.depts,
      });

    case SET_SELECTED_DEPT:
      return Object.assign({}, state, {
        selectedDept: action.selectedDept,
      });

    case GET_STATES:
      return Object.assign({}, state, {
        states: action.states,
      });

    case GET_TIMEZONES:
      return Object.assign({}, state, {
        timezones: action.timezones,
      });

    case GET_ASSIGNED_ORGS:
      return Object.assign({}, state, {
        orgs: action.orgs,
      });

    case REFRESH_TOKEN:
      return Object.assign({}, state, {
        token: action.token,
      });

    case TOGGLE_EMAIL_UPDATE:
      return {
        ...state,
        user: {
          ...state.user,
          allUpdates: action.emailUpdate.allUpdates,
        },
      };

    default:
      return state;
  }
};

export default AyucareUsersReducer;
